import { render, staticRenderFns } from "./ModalForm.vue?vue&type=template&id=be263d76&"
import script from "./ModalForm.vue?vue&type=script&lang=js&"
export * from "./ModalForm.vue?vue&type=script&lang=js&"
import style0 from "./ModalForm.vue?vue&type=style&index=0&id=be263d76&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports